export default {
  title: 'Get in touch',
  studentMail: 'Mail for students og members',
  otherMail: 'Mail for other inquiries',
};
